// Single source of truth for authenticated navigation items.
// Used by both Sidebar (left rail) and Header (user dropdown)
// so they never drift out of order.

import {
  LayoutDashboard,
  Sparkles,
  Wand2,
  FileText,
  LayoutGrid,
  Search,
  Briefcase,
  PenLine,
  Linkedin,
  MessageSquare,
  Gift,
  CreditCard,
  TrendingUp,
  Users,
  Mail,
} from 'lucide-react';

export const USER_NAV_ITEMS = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/coach', icon: Sparkles, label: 'Sage' },
  { to: '/builder', icon: Wand2, label: 'Resume Builder' },
  { to: '/resume/new', icon: FileText, label: 'Quick Resume' },
  { to: '/templates', icon: LayoutGrid, label: 'Templates' },
  { to: '/jobs', icon: Search, label: 'Job Board' },
  { to: '/applications', icon: Briefcase, label: 'Applications' },
  { to: '/cover-letter', icon: PenLine, label: 'Cover Letter' },
  { to: '/linkedin-optimizer', icon: Linkedin, label: 'LinkedIn' },
  { to: '/interview-prep', icon: MessageSquare, label: 'Interview Prep' },
  { to: '/referral', icon: Gift, label: 'Referrals' },
  { to: '/pricing', icon: CreditCard, label: 'Subscription' },
];

export const ADMIN_NAV_ITEMS = [
  { to: '/admin/funnel', icon: TrendingUp, label: 'Funnel' },
  { to: '/admin/users', icon: Users, label: 'Users' },
  { to: '/admin/broadcast', icon: Mail, label: 'Broadcast' },
];
